import { LaunchDarklyFlag, useFlag } from '@fhs-legacy/frontend/src/state/launchdarkly';

export const useHomepageReorderEnabled = () => {
  const isHomepageReorderEnabled = useFlag(LaunchDarklyFlag.ENABLE_HOMEPAGE_REORDER);
  const isReorderEnabled = useFlag(LaunchDarklyFlag.ENABLE_REORDER);

  // Even if the new Homepage reorder feature is enabled, we shouldn't have it working if Reorder itself is disabled
  return isHomepageReorderEnabled && isReorderEnabled;
};
